function ModeButton(props) {
    return (
    <div style={{
        marginLeft: `${props.screenSize.width - 180}px`,
        marginTop: '5px',
        transition: '.5s'
      }}>
                    <div style={{
                        position: 'absolute',
                        width: '30px',
                        height: '30px',
                        border: props.mode === 'dark' ? '1px solid #f1eee6' : '1px solid #28282b',
                        // marginLeft: `${props.screenSize.width - 1000}px`,
                        // marginTop: `${props.screenSize.height - 1225}px`,
                        cursor: 'pointer',
                        transition: '.5s'
                    }} onClick={() => props.handleModeSelect()}>
                      <div style={{
                        position: 'absolute',
                        width: '15px',
                        height: '15px',
                        border: props.mode === 'dark' ? '1px solid #f1eee6' : '1px solid #28282b',
                        borderRadius: '50%',
                        marginLeft: '6.5px',
                        marginTop: '6.5px',
                        transition: '.5s',
                        pointerEvents: 'none',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : ''
                      }}></div>
                      {/* top middle */}
                      <div style={{
                        position: 'absolute',
                        width: '1px',
                        height: '3px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '14.5px',
                        marginTop: '2px',
                        transition: props.mode === 'light' ? '1.2s' : '.5s',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* right top */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '23px',
                        marginTop: '6px',
                        transition: props.mode === 'light' ? '1.1s' : '.6s',
                        transform: 'rotate(-45deg)',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* right middle */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '25px',
                        marginTop: '14.5px',
                        transition: props.mode === 'light' ? '1s' : '.7s',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* right bottom */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '22px',
                        marginTop: '23px',
                        transition: props.mode === 'light' ? '.9s' : '.8s',
                        transform: 'rotate(45deg)',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* bottom middle */}
                      <div style={{
                        position: 'absolute',
                        width: '1px',
                        height: '3px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '14.5px',
                        marginTop: '25px',
                        transition: props.mode === 'light' ? '.8s' : '.9s',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* left bottom */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '5px',
                        marginTop: '23px',
                        transition: props.mode === 'light' ? '.7s' : '1s',
                        transform: 'rotate(-45deg)',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* left middle */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '2px',
                        marginTop: '14.5px',
                        transition: props.mode === 'light' ? '.6s' : '1.1s',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      {/* left top */}
                      <div style={{
                        position: 'absolute',
                        width: '3px',
                        height: '1px',
                        backgroundColor: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                        marginLeft: '4px',
                        marginTop: '6px',
                        transition: props.mode === 'light' ? '.5s' : '1.2s',
                        transform: 'rotate(45deg)',
                        opacity: props.mode === 'dark' ? '0%' : '100%'
                      }}>
                      </div>
                      
                      
                      
                        
                    </div>
                </div>
    )
}

export default ModeButton